export class W3FormManipulation {
  private fileUploadElement: HTMLInputElement | null;

  constructor() {
    this.fileUploadElement = document.querySelector(
      ".elementor-field-type-upload",
    );
    console.log(this.fileUploadElement);

    if (!this.fileUploadElement) return;
    this.hideFirstSelectOption();
  }

  private hideFirstSelectOption() {
    const selectElement = document.querySelector(
      ".elementor-select-wrapper select",
    );
    if (!selectElement) return;

    const firstOption = selectElement.querySelector("option");
    console.log(firstOption);

    if (!firstOption) return;
    //adddisabletofirstoption
    firstOption.disabled = true;
    firstOption.style.display = "none";
  }
}
